import type { Special } from '@/mocks/specials';
import type { Movie } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

interface SpecialSectionProps {
  special: Special;
  list: Movie[];
}

export default function SpecialSection({ special, list }: SpecialSectionProps) {
  return (
    <section id={special.id} className="scroll-mt-24">
      <div className="relative h-48 w-full overflow-hidden rounded-lg md:h-64">
        <img
          src={special.cover}
          alt={`${special.title} 专题主视觉`}
          title={`${special.title} 影视专题`}
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-background-950/50 to-transparent"></div>
        <div className="absolute inset-0 flex flex-col justify-center px-5 md:px-10">
          <span className="inline-flex w-fit items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
            <i className="ri-article-line"></i>
            专题策划
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-background-50 md:text-3xl">{special.title}</h2>
        </div>
      </div>

      <p className="mt-5 max-w-3xl text-sm leading-relaxed text-foreground-700 md:text-base">{special.intro}</p>

      <div className="mt-5 rounded-lg border-l-4 border-accent-500 bg-accent-50 px-5 py-4">
        <p className="text-sm leading-relaxed text-accent-900">{special.editorNote}</p>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-3 md:gap-5 lg:grid-cols-4">
        {list.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}